import _baidu from "@/monitor/_baidu";
import _toutiao from "@/monitor/_toutiao";
import _kuaishou from "@/monitor/_kuaishou";
import _uc from "@/monitor/_uc";
import _weibo from "@/monitor/_weibo";
import _tencent from "@/monitor/_tencent";
import _bilibili from "@/monitor/_bilibili";
import _vivo from "@/monitor/_vivo";
import lib_activity from "@/libs/lib_activity";
import ca from "element-ui/src/locale/lang/ca";
import _object from "@/utils/_object";

//百度-搜索
const BAIDU_SEARCH = 1;
//百度-信息流
const BAIDU_IFLOW = 2;
//头条
const TOUTIAO = 3;
//快手
const KUAISHOU = 4;
//腾讯-广点通
const TENCENT = 5;
//微博
const WEIBO = 6;
//UC
const UC = 7;
//搜狗
const SOGOU = 9;
//360
const E360 = 10;
//小红书
const XIAOHONGSHU = 14;
//B站
const BILIBILI = 15;
//VIVO
const VIVO = 21;


let _monitor = {

    //标记列表
    mark_list: [],

    //渠道
    channel: 0,

    //加载标记
    init: function(channel, activity_id){
        //初始化渠道
        this.channel = channel

        if (channel != TOUTIAO && channel != KUAISHOU && channel != TENCENT && channel != WEIBO && channel != UC) {
            //无标记渠道同步加载
            this.load()
            return
        }

        let that = this
        lib_activity.monitor(activity_id, channel, function (data) {
            if (_object._length(data) > 0) {
                that.mark_list = data
            }
            //有标记渠道异步加载
            that.load()
        })
    },


    //加载基础代码
    load: function(){

        try {
            if (this.channel == BAIDU_SEARCH || this.channel == BAIDU_IFLOW) {
                //百度
                _baidu.load()
            } else if (this.channel == TOUTIAO) {
                //头条
                _toutiao.load()
            } else if (this.channel == KUAISHOU) {
                //快手
                _kuaishou.load()
            } else if (this.channel == TENCENT) {
                //广点通
                for (let i in this.mark_list) {
                    _tencent.load(this.mark_list[i])
                }
            } else if (this.channel == WEIBO) {
                //微博
                _weibo.load()
            } else if (this.channel == UC) {
                //UC
                _uc.load()
            } else if (this.channel == BILIBILI) {
                //B站
                _bilibili.load()
            } else if (this.channel == VIVO) {
                //VIVO
                _vivo.load()
            }
        } catch (e) {
            console.log(e)
        }
    },

    //加载事件代码
    submit: function () {
        try {
            if (this.channel == BAIDU_SEARCH || this.channel == BAIDU_IFLOW) {
                console.log(111, '百度')
                //百度
                _baidu.submit()
            } else if (this.channel == TOUTIAO) {
                //头条
                console.log(111, '头条', this.mark_list)
                for (let i in this.mark_list) {
                    _toutiao.submit(this.mark_list[i])
                }
            } else if (this.channel == KUAISHOU) {
                //快手
                for (let i in this.mark_list) {
                    _kuaishou.submit(this.mark_list[i])
                }
            } else if (this.channel == TENCENT) {
                //广点通
                _tencent.submit()
            } else if (this.channel == WEIBO) {
                //微博
                for (let i in this.mark_list) {
                    _weibo.submit(this.mark_list[i])
                }
            } else if (this.channel == UC) {
                //UC
                for (let i in this.mark_list) {
                    _uc.submit(this.mark_list[i])
                }
            } else if (this.channel == BILIBILI) {
                //B站
                _bilibili.submit()
            } else if (this.channel == VIVO) {
                //VIVO
                _vivo.submit()
            }
        } catch (e) {
            console.log(e)
        }
    },
};

export default _monitor
